import { FC } from 'react';
import { ArrowLeftDenseIcon, Button } from '@rubin-dev/goblin';
import { useGoBack } from '@hooks/useGoBack';
import cls from './style.module.scss';

export type GraphBackButtonProps = {};
export const GraphBackButton: FC<GraphBackButtonProps> = () => {
  const goBack = useGoBack();
  return (
    <Button
      icon
      className={cls.button}
      prependIcon={ArrowLeftDenseIcon}
      variant="outlined"
      onClick={() => goBack()}
    />
  );
};
